import { render, staticRenderFns } from "./articleBtn.vue?vue&type=template&id=4425a392&scoped=true"
import script from "./articleBtn.vue?vue&type=script&lang=js"
export * from "./articleBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4425a392",
  null
  
)

export default component.exports